var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "topBox" }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", { staticClass: "banners", attrs: { src: _vm.bannerImg } }),
          _vm._v(" "),
          _c("div", { staticClass: "logo_name" }, [
            _c("img", { staticClass: "head_img", attrs: { src: _vm.logoUrl } }),
            _vm._v(" "),
            _c("div", { staticClass: "user_message" }, [
              _c("div", { staticClass: "user_name" }, [
                _vm._v(_vm._s(_vm.names))
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card_numbers" }, [
              _vm._v("NO:" + _vm._s(_vm.tateData.VIPNO))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "head_content" },
            [
              _c("div", { staticClass: "con_item paddingline" }, [
                _c("p", { staticClass: "con_text_tit" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.tateData.Integral ? _vm.tateData.Integral : 0
                      ) +
                      "分\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "con_text" }, [_vm._v("积分")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "con_item paddingline" }, [
                _c("p", { staticClass: "con_text_tit" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.tateData.Money
                          ? _vm.toFix(Number(_vm.tateData.Money))
                          : 0
                      ) +
                      "元\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "con_text" }, [_vm._v("余额")])
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "con_item", attrs: { to: "/myCoupon" } },
                [
                  _c("p", { staticClass: "con_text_tit" }, [
                    _vm._v(_vm._s(_vm.cardLength) + "张")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "con_text" }, [_vm._v("优惠券")])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mains" }, [
          _c(
            "div",
            { staticClass: "main_con" },
            [
              _vm.bindStatus === true
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/PaymentCode" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/zf.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("支付")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus === true
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/Recharge" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "borderline",
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/hycz.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("充值")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus === true
                ? _c(
                    "router-link",
                    {
                      staticClass: "main_item",
                      attrs: { to: "/consumptionRecord" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/xfjl.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("消费记录")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus === true
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/Detail" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/czjll.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("充值记录")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus === true
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/myCoupon" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "borderline",
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg cardlogo",
                            attrs: { src: "/static/image/kq.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text card_text" }, [
                            _vm._v("卡券")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.bindStatus == true
              ? true
              : false)
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/Integral" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/jfjl.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("积分记录")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.bindStatus == true
              ? true
              : false)
                ? _c(
                    "router-link",
                    {
                      staticClass: "main_item",
                      attrs: { to: "/IntegralExchange" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/jfdh.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("积分兑换")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus !== true
                ? _c(
                    "router-link",
                    {
                      staticClass: "main_item",
                      attrs: { to: "/BindingMember" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/bangkas.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("绑卡")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bindStatus !== true &&
              _vm.companyID !== "61ca6ef251aeb2275ba7b084"
                ? _c(
                    "router-link",
                    { staticClass: "main_item", attrs: { to: "/Registers" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "borderline",
                          staticStyle: {
                            "text-align": "center",
                            width: "100%",
                            "border-right": "none"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg",
                            attrs: { src: "/static/image/zhuces.png" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "main_text" }, [
                            _vm._v("注册")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !!(_vm.bindStatus === true && _vm.bannerAct.length)
                ? _c(
                    "router-link",
                    {
                      staticClass: "main_item",
                      attrs: { to: "/activeCenter" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "borderline",
                          staticStyle: { "text-align": "center", width: "100%" }
                        },
                        [
                          _c("img", {
                            staticClass: "main_headimg actlogo",
                            attrs: { src: "/static/image/activecenter.png" }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "main_text card_text",
                              staticStyle: { "margin-top": "13px" }
                            },
                            [_vm._v("\n              活动中心\n            ")]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.bindStatus === true,
                      expression: "bindStatus === true"
                    }
                  ],
                  staticClass: "main_item",
                  on: {
                    click: function($event) {
                      return _vm.clickRelieve()
                    }
                  }
                },
                [_vm._m(1)]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.binding
        ? _c("div", { staticClass: "Choice" }, [
            _c("div", { staticClass: "cho1" }, [_vm._v("是否解除绑定")]),
            _vm._v(" "),
            _c("div", { staticClass: "cho2" }, [
              _c(
                "div",
                {
                  staticStyle: { "border-right": "1px solid #e0e0e0" },
                  on: {
                    click: function($event) {
                      return _vm.clickBinding(false)
                    }
                  }
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.clickBinding(true)
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.reload
        ? _c("div", { staticClass: "ChoiceVersion" }, [
            _c("div", { staticClass: "choHeight" }, [
              _vm._v(
                "\n      当前版本为:" +
                  _vm._s(_vm.version) +
                  ", 线上最新版本为" +
                  _vm._s(_vm.newVersion) +
                  ",\n      低版本可能会导致部分功能失效, 请刷新页面以更新到最新版本或点击下方按钮。\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cho3 chociceChange" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.clickReload()
                    }
                  }
                },
                [_vm._v("现在更新")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.versionModal > 10
        ? _c("div", { staticClass: "Choice2" }, [
            _c("div", { staticClass: "cho1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.adminPass,
                    expression: "adminPass"
                  }
                ],
                attrs: { placeholder: "管理员密码" },
                domProps: { value: _vm.adminPass },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.adminPass = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cho1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.adminVersion,
                    expression: "adminVersion"
                  }
                ],
                attrs: { placeholder: "最新版本号" },
                domProps: { value: _vm.adminVersion },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.adminVersion = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cho3" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.changeVersionModal()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "div",
            { staticClass: "coupon" },
            [
              _c("div", { staticClass: "coupon_main" }, [_vm._v("优惠券")]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "routerLink",
                  attrs: { to: "/Actives/?type=tanceng" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "coupon_sure",
                      on: {
                        click: function($event) {
                          return _vm.getCoupon(true)
                        }
                      }
                    },
                    [_vm._v("确定领取")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "coupon_false",
                  on: {
                    click: function($event) {
                      return _vm.getCoupon(false)
                    }
                  }
                },
                [_vm._v("x")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.prom ? _c("Promptbox", { attrs: { message: _vm.Tips } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "banbenhao",
          on: {
            click: function($event) {
              return _vm.clickVersionModal()
            }
          }
        },
        [_vm._v(_vm._s(_vm.version))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "none",
            "this is padding data":
              "填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充"
          }
        },
        [
          _vm._v(
            "\n    this is padding\n    data:填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.load || _vm.reload ? _c("div", { staticClass: "mask" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "8px",
          display: "flex",
          "justify-content": "space-between",
          width: "84px",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("普通会员")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "borderline",
        staticStyle: { "text-align": "center", width: "100%" }
      },
      [
        _c("img", {
          staticClass: "main_headimg",
          attrs: { src: "/static/image/jcbd.png" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "main_text" }, [_vm._v("解除绑定")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bd8a2ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd8a2ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BindingMenmberCard/index.vue
// module id = null
// module chunks = 